import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/styles';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Typography,
  Card,
  Grid,
  Button,
  Fab,
  Box,
  CircularProgress,
  Backdrop
} from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EmailIcon from '@material-ui/icons/Email';
import PrintIcon from '@material-ui/icons/Print';
import AddIcon from '@material-ui/icons/Add';
import PageviewIcon from '@material-ui/icons/Pageview';
import ReceiptIcon from '@material-ui/icons/Receipt';
import { useReactToPrint } from 'react-to-print';
import { request } from '../authentication/axiosTools';
import Card1 from '../Card1';
import { useClientContext } from '../../context/client_context';
import { baseUrl } from '../../utils/constants';
import Controls from '../controls/Controls';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  color: {
    backgroundColor: '#000000'
  },
  newButton: {
    position: 'absolute',
    right: '10px'
  }
}));

export default function PrintStatement() {
  const classes = useStyles();
  const { id } = useParams();
  const { currentClient } = useClientContext();
  //   const { loanRefId } = useLoanContext();
  const [htmlData, setHtmlData] = React.useState('Loading Statement...');
  const [showPreDoc, setShowPreDoc] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const componentRef = useRef();
  console.log('current client', currentClient);

  useEffect(() => {
    getStatement();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePrint = () => {
    handleReactToPrint();
  };

  const handleReactToPrint = useReactToPrint({
    content: () => componentRef.current
  });

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const getStatement = async () => {
    setLoading(true);
    // request({
    //   url: `/api/Client/GetClientLoanStatement?customerIdentifier=${currentClient.id}&loanRefId=${currentClient.cif_number}&notificationLanguage=0`,
    //   method: 'post'
    // }).then(
    await axios(
      `${baseUrl}/api/Client/GetClientLoanStatement?clientRefId=${currentClient.cif_number}&accountRefId=${currentClient.cif_number}&tableId=${id}&notificationLanguage=0`
    ).then(
      (result) => {
        setLoading(false);
        if (result.data.replyStatus === 0) {
          setHtmlData(result.data.messageBody);
          notifyPopup('Member Statement Retrieved Successfully', 'success');
          setShowPreDoc(true);
        } else {
          notifyPopup('Error - Member Statement Not Retrieved', 'error');
        }
      },
      (error) => {
        setLoading(false);
        notifyPopup(`Error in Disbursing Payment!: ${error}`, 'error');
      }
    );
  };

  const emailClient = () => {
    setLoading(true);
    handleChange('panel1');
    request({
      url: `/api/Client/EmailClient?entityName=Statement&clientRefid=${currentClient.cif_number}`,
      method: 'post'
    }).then(
      (result) => {
        setLoading(false);
        // if (result.data.replyStatus === 0) {
        //   // setHtmlData(result.data.messageBody);
        //   notifyPopup('Member Statement Sent Successfully', 'success');
        //   setShowPreDoc(true);
        // } else {
        //   notifyPopup('Error - Member Statement NOT Sent', 'error');
        // }
      },
      (error) => {
        notifyPopup(`Member Statement NOT Sent!: ${error}`, 'error');
      }
    );
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container direction="row" margin={3} justifyContent="left" alignItems="left">
        <Grid item xs={12} sm={1}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<EmailIcon />}
            onClick={() => emailClient()}
          >
            Email
          </Button>
        </Grid>
      </Grid>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className={classes.color}
        >
          <Typography className={classes.heading} color="#FFFFFF">
            Ordinary Statement
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Card sx={{ ml: 10, mt: 3, mr: 10, mb: 10 }}>
            <Grid container spacing={1} sx={{ m: 1, ml: 0 }}>
              <Grid item xs={12} sm={2}>
                <Fab size="small" color="error" aria-label="add" onClick={() => handlePrint()}>
                  <PrintIcon />
                </Fab>
                <div style={{ display: 'none' }}>
                  <StatementToPrint printData={htmlData} ref={componentRef} />
                </div>
              </Grid>
            </Grid>
            <Card1 sx={{ height: '50vw', overflow: 'auto' }}>
              <div
                dangerouslySetInnerHTML={{
                  __html: htmlData
                }}
              />
            </Card1>
          </Card>
        </AccordionDetails>
      </Accordion>
      <Controls.Notification notify={notify} setNotify={setNotify} />
    </>
  );
}

export const StatementToPrint = React.forwardRef((props, ref) => {
  const { printData } = props;
  console.log('html data here', printData);
  return (
    <Box ref={ref} m={4}>
      <div
        dangerouslySetInnerHTML={{
          __html: printData
        }}
      />
      {/* {printData} */}
    </Box>
  );
});
